module.exports = __webpack_public_path__ + "img/parrillada-mixta.4de36f67.jpg";